// extracted by mini-css-extract-plugin
module.exports =  {"hidden":"_5KUbZ","visible":"Ek38Qk","collapsed":"C1jcae"};